import {
  DocumentReference,
  isDocRef,
  TypeGuard,
} from '@principle-theorem/shared';
import { isString } from 'lodash';
import { IPractice } from '../practice/practice';
import { IStaffer } from '../staffer/staffer';

/**
 * Request payload for the `http-aiScribe-mintToken` callable. Identifies the
 * staffer and practice the caller is minting a VoxDenta session token for, plus
 * the scribe session the token is scoped to.
 */
export interface IMintTokenRequest {
  practiceRef: DocumentReference<IPractice>;
  stafferRef: DocumentReference<IStaffer>;
  sessionId: string;
}

export const isMintTokenRequest = TypeGuard.interface<IMintTokenRequest>({
  practiceRef: isDocRef,
  stafferRef: isDocRef,
  sessionId: isString,
});

/**
 * Response from the `http-aiScribe-mintToken` callable. `expiresAt` is the token
 * expiry as epoch milliseconds so the client can schedule a refresh without
 * re-parsing the vendor's relative `expiresIn`.
 */
export interface IMintTokenResponse {
  token: string;
  expiresAt: number;
}
